module.exports = __webpack_public_path__ + "72a8c2fc0bd5193c551eef7bfa48e774.png";